import { render } from "./AppointmentsOverview.vue?vue&type=template&id=0e7c3116"
const script = {}

import exportComponent from "/Users/bastiaanboekling/devops/afspraken/afspraken-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__